var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ml-4 dropdown"},[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"data-toggle":"dropdown"}},[_c('i',{class:_vm.icon})]),_c('div',{staticClass:"dropdown-menu dropdown-menu-right"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }